import { apiSlice } from './apiSlice';

// Responses have already passed through the shared camelCase interceptor.
export interface FinancialKpis {
  reportDate: string;
  statementTotals: { revenue: string; netIncome: string };
  profitability: { grossMarginPercent: string | null };
  liquidity: { cashAndReceivables: string; currentRatio: string | null; quickRatio: string | null };
  efficiency: { accountsReceivableDays: string | null; accountsPayableDays: string | null };
}

export interface FinancialKpiTrend {
  series: Array<{ period: string; revenue: string; netIncome: string | null }>;
}

interface Envelope<T> { success: boolean; data: T }

export const financialKpiApi = apiSlice.injectEndpoints({
   // Adjust baseUrl based on your actual api routing
  endpoints: (builder) => ({
    getFinancialKpis: builder.query<Envelope<FinancialKpis>, Record<string, any> | void>({
      query: (params) => ({
        url: '/api/financial-statements/kpis',
        params: params || undefined,
      }),
      providesTags: ['Accounting', 'DashboardStats'],
    }),
    getFinancialKpiTrend: builder.query<Envelope<FinancialKpiTrend>, Record<string, any> | void>({
      query: (params) => ({
        url: '/api/financial-statements/kpis/trend',
        params: params || undefined,
      }),
      providesTags: ['Accounting', 'DashboardStats'],
    }),
  }),
});

export const {
  useGetFinancialKpisQuery,
  useLazyGetFinancialKpisQuery,
  useGetFinancialKpiTrendQuery,
  useLazyGetFinancialKpiTrendQuery,
} = financialKpiApi;

// Alias exports for compatibility
export const useGetKpisQuery = useGetFinancialKpisQuery;
export const useGetTrendQuery = useGetFinancialKpiTrendQuery;
